import classNames from 'classnames'
import React from 'react'

export const FTUWizardHeader = ({
  wizardStepCount,
  wizardActiveStep,
}: {
  wizardStepCount: number
  wizardActiveStep: number
}) => {
  const activeStyle =
    'h-7.5 w-7.5 bg-primaryAccentColor rounded-full flex items-center justify-center text-white flex-shrink-0'

  const nonActiveStyle =
    'h-7.5 w-7.5 bg-white border border-primaryAccentColor rounded-full flex items-center justify-center text-primaryAccentColor flex-shrink-0'

  if (wizardStepCount < 2) {
    return null
  }
  return (
    <div className="flex flex-row items-center justify-center md:my-6">
      {Array.from({ length: wizardStepCount }, (_, i) => 1 + i).map((v, i, a) => {
        if (i < a.length - 1) {
          return (
            <React.Fragment key={`w${i}`}>
              <div
                className={
                  wizardActiveStep == i ? classNames(activeStyle) : classNames(nonActiveStyle)
                }
              >
                {i + 1}
              </div>
              <hr className="h-px w-15 bg-borderColor border-0 mx-2.5" />
            </React.Fragment>
          )
        } else {
          return (
            <div
              key={`w${i}`}
              className={
                wizardActiveStep == i ? classNames(activeStyle) : classNames(nonActiveStyle)
              }
            >
              {i + 1}
            </div>
          )
        }
      })}
    </div>
  )
}
